import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as configAction from '../store/BomLibrary.action';
import '../../../DevlopmentOrder/Bom/BomTags/BomTags.css';

function BomLibraryTagsInput(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const suggestdata = useSelector((state) => state.BomLibraryDetails.tagsList);
  const TagsList = useSelector((state) => state.BomLibraryDetails.tagsListById);
  const [tags, setTags] = useState(TagsList);

  useEffect(() => {
    dispatch(configAction.fetchBomLibraryTagsAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [0]);

  useEffect(() => {
    dispatch(configAction.fetchBomLibraryTagsById(props.bomComponentId));
  }, [dispatch, props.bomComponentId]);

  useEffect(() => {
    setTags(TagsList);
  }, [TagsList]);

  console.log(tags, TagsList);

  const handleChange = (e) => {
    const { value } = e.target;
    setInput(value);
    handleSuggestion(value);
  };
  const handleKeyDown = (e) => {
    if (e.keyCode === 9) {
      e.preventDefault();
    }
    const text = suggestions.length ? suggestions : input;
    if ([9, 13].includes(e.keyCode) && text) {
      AddTags(input);
    }
  };
  const handleSuggestion = (value) => {
    const suggestFilterInput = suggestdata.filter((suggest) => suggest.toLowerCase().includes(value.toLowerCase()));
    const suggestFilterTags = suggestFilterInput.filter((suggest) => !tags.includes(suggest));
    setSuggestions(suggestFilterTags);
  };
  const handleDelete = (i) => {
    const newTags = tags.filter((tag, j) => i !== j);
    setTags(newTags);
    props.tagsInputs(newTags);
  };

  const handleSuggestremove = (i) => {
    const suggestFilter = suggestions.filter((j) => i !== j);
    setSuggestions(suggestFilter);
  };

  const AddTags = async (text) => {
    if (text) {
      setTags([...tags, text]);
      setInput('');
    }
    props.tagsInputs([...tags, text]);
  };
  return (
    <div>
      <div className="tags-content">
        <div className="inner-tag">
          <input
            type="text"
            value={input}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder={t('BOM_LIBRARY.BOM_LIBRARY_TAG.BOM_LIBRARY_TAG_INPUT.ADD_TAG')}
          />
          {input && Boolean(suggestions.length) && (
            <div className="suggetions-list">
              {suggestions.map((suggest) => (
                <div className="suggestbox" key={suggest.id}>
                  <div className="" onClick={() => AddTags(suggest)}>
                    <p className="iteamList">{suggest}</p>
                  </div>
                  <div className="remove-tag" onClick={() => handleSuggestremove(suggest)}>
                    ×
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="textview">
        {tags.map((tag, i) => (
          <div key={tag} className="tag">
            {tag}
            <div className="remove-tag" onClick={() => handleDelete(i)}>
              ×
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BomLibraryTagsInput;
